import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconEdit: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.0738 4.82355L17.4775 1.21427C16.5059 0.298325 15.0045 0.258672 13.9862 1.12206L2.1736 12.9773C1.74935 13.4067 1.48519 13.9695 1.42546 14.5712L0.861083 20.0642C0.825286 20.4548 0.96482 20.8411 1.24171 21.118C1.48941 21.3645 1.82473 21.502 2.1736 21.5H2.29172L7.76491 20.9994C8.36446 20.9395 8.92521 20.6744 9.35305 20.2486L21.1657 8.39331C22.1203 7.38121 22.0792 5.78484 21.0738 4.82355V4.82355ZM16.6112 9.22318L13.0937 5.69293L15.6531 3.05843L19.2363 6.65453L16.6112 9.22318Z"
        fill="#1E2846"
      />
    </svg>
  </IconStyled>
);

IconEdit.defaultProps = iconDefaultProps;
IconEdit.displayName = 'IconEdit';

export default IconEdit;
